import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import * as searchActions from "../../../../_actions/searchActions";
import FilterWidget from "../../../UI/FilterWidget";
import Slider from "../../../UI/Slider";
import Select from "../../../UI/Select";
import Wrapper from "../../../../_hoc/Wrapper";
import getMaritalStatus from "../../../../_selectors/dataSelectors/getMaritalStatus";
import getMotherTongue from "../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../_selectors/dataSelectors/getReligion";
import getMyGender from "../../../../_selectors/userSelectors/getMyGender";
import getBodyType from "../../../../_selectors/dataSelectors/getBodyType";
import getEducation from "../../../../_selectors/dataSelectors/getEducation";
import getJobType from "../../../../_selectors/dataSelectors/getJobType";
import getIncome from "../../../../_selectors/dataSelectors/getIncome";
import getHeight from "../../../../_selectors/dataSelectors/getHeight";
import getComplexion from "../../../../_selectors/dataSelectors/getComplexion";
import getFamilyType from "../../../../_selectors/dataSelectors/getFamilyType";
import getFamilyValue from "../../../../_selectors/dataSelectors/getFamilyValue";
import getFamilyStatus from "../../../../_selectors/dataSelectors/getFamilyStatus";
import getDiet from "../../../../_selectors/dataSelectors/getDiet";
import getHabitType from "../../../../_selectors/dataSelectors/getHabitType";
import getManglik from "../../../../_selectors/dataSelectors/getManglik";
import getMoonSign from "../../../../_selectors/dataSelectors/getMoonSign";
import getCountry from "../../../../_selectors/dataSelectors/getCountry";
import getState from "../../../../_selectors/dataSelectors/getState";
class Filter extends Component {
  state = {
    showFilter: true,
    ageStart: 24,
    ageEnd: 27,
    selectedMaritalStatus: [],
    selectedMotherTongue: [],
    selectedReligion: [],
    selectedEducation: [],
    selectedJobType: [],
    selectedIncome: [],
    selectedHeight: [],
    selectedComplexion: [],
    selectedBodyType: [],
    selectedFamilyType: [],
    selectedFamilyStatus: [],
    selectedFamilyValues: [],
    selectedDiet: [],
    selectedSmoke: [],
    selectedDrink: [],
    selectedManglik: [],
    selectedMoonsign: [],
    selectedCountry: [],
    selectedState: []
  };
  componentDidMount() {
    const {
      maritalStatus,
      getMaritalStatusData,
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData,
      bodyType,
      getBodyTypeData,
      education,
      getEducationData,
      jobType,
      getJobTypeData,
      income,
      getIncomeData,
      height,
      getHeightData,
      complexion,
      getComplexionData,
      familyType,
      getFamilyTypeData,
      familyValue,
      getFamilyValueData,
      familyStatus,
      getFamilyStatusData,
      diet,
      getDietData,
      habitType,
      getHabitTypeData,
      manglik,
      getManglikData,
      moonSign,
      getMoonSignData,
      country,
      getCountryData
    } = this.props;

    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
    if (bodyType.length === 0) {
      getBodyTypeData();
    }
    if (education.length === 0) {
      getEducationData();
    }
    if (jobType.length === 0) {
      getJobTypeData();
    }
    if (income.length === 0) {
      getIncomeData();
    }
    if (height.length === 0) {
      getHeightData();
    }
    if (complexion.length === 0) {
      getComplexionData();
    }
    if (familyStatus.length === 0) {
      getFamilyStatusData();
    }
    if (familyType.length === 0) {
      getFamilyTypeData();
    }
    if (familyValue.length === 0) {
      getFamilyValueData();
    }
    if (diet.length === 0) {
      getDietData();
    }
    if (habitType.length === 0) {
      getHabitTypeData();
    }
    if (manglik.length === 0) {
      getManglikData();
    }
    if (moonSign.length === 0) {
      getMoonSignData();
    }
    if (country.length === 0) {
      getCountryData();
    }
  }
  toggleShowFilter = () => {
    this.setState(prevState => ({ showFilter: !prevState.showFilter }));
  };
  search = () => {
    const {
      ageEnd,
      ageStart,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      selectedBodyType,
      selectedComplexion,
      selectedCountry,
      selectedDiet,
      selectedDrink,
      selectedEducation,
      selectedFamilyStatus,
      selectedFamilyType,
      selectedFamilyValues,
      selectedHeight,
      selectedIncome,
      selectedJobType,
      selectedManglik,
      selectedMoonsign,
      selectedSmoke,
      selectedState
    } = this.state;
    const { search, isFemale } = this.props;
    search({
      data: {
        ageEnd,
        ageStart,
        maritalStatus: selectedMaritalStatus,
        motherTongue: selectedMotherTongue,
        religion: selectedReligion,
        bodyType: selectedBodyType,
        complexion: selectedComplexion,
        diet: selectedDiet,
        drink: selectedDrink,
        education: selectedEducation,
        familyStatus: selectedFamilyStatus,
        familyType: selectedFamilyType,
        familyValue: selectedFamilyValues,
        height: selectedHeight,
        income: selectedIncome,
        jobType: selectedJobType,
        manglik: selectedManglik,
        moonSign: selectedMoonsign,
        smoke: selectedSmoke,
        isFemale
      }
    });
    this.toggleShowFilter();
  };
  render() {
    const {
      showFilter,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      ageEnd,
      ageStart,
      selectedBodyType,
      selectedComplexion,
      selectedCountry,
      selectedDiet,
      selectedDrink,
      selectedEducation,
      selectedFamilyStatus,
      selectedFamilyType,
      selectedFamilyValues,
      selectedHeight,
      selectedIncome,
      selectedJobType,
      selectedManglik,
      selectedMoonsign,
      selectedSmoke,
      selectedState
    } = this.state;
    const {
      maritalStatus,
      motherTongue,
      religion,
      bodyType,
      complexion,
      country,
      state,
      diet,
      drink,
      education,
      familyStatus,
      familyType,
      familyValue,
      height,
      income,
      jobType,
      manglik,
      moonSign,
      habitType,
      getStateData
    } = this.props;
    return (
      <FilterWidget
        show={showFilter}
        onToggle={this.toggleShowFilter}
        onSearch={this.search}
      >
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-sm-12">
              <Slider
                min={21}
                max={80}
                defaultValue={[0, 0]}
                value={[ageStart, ageEnd]}
                label={<Wrapper>Age</Wrapper>}
                multi
                onChange={(start, end) => {
                  this.setState({ ageStart: start, ageEnd: end });
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Marital Status</Wrapper>}
                selected={selectedMaritalStatus}
                options={maritalStatus}
                onChange={value => {
                  this.setState({ selectedMaritalStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Religion</Wrapper>}
                selected={selectedReligion}
                options={religion}
                onChange={value => {
                  this.setState({ selectedReligion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Mother Tongue</Wrapper>}
                selected={selectedMotherTongue}
                options={motherTongue}
                onChange={value => {
                  this.setState({ selectedMotherTongue: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Education</Wrapper>}
                selected={selectedEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Job Type</Wrapper>}
                selected={selectedJobType}
                options={jobType}
                onChange={value => {
                  this.setState({ selectedJobType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Income</Wrapper>}
                selected={selectedIncome}
                options={income}
                onChange={value => {
                  this.setState({ selectedIncome: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Height</Wrapper>}
                selected={selectedHeight}
                options={height}
                onChange={value => {
                  this.setState({ selectedHeight: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Complexion</Wrapper>}
                selected={selectedComplexion}
                options={complexion}
                onChange={value => {
                  this.setState({ selectedComplexion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Body Type</Wrapper>}
                selected={selectedBodyType}
                options={bodyType}
                onChange={value => {
                  this.setState({ selectedBodyType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Family Type</Wrapper>}
                selected={selectedFamilyType}
                options={familyType}
                onChange={value => {
                  this.setState({ selectedFamilyType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Family Status</Wrapper>}
                selected={selectedFamilyStatus}
                options={familyStatus}
                onChange={value => {
                  this.setState({ selectedFamilyStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Family Values</Wrapper>}
                selected={selectedFamilyValues}
                options={familyValue}
                onChange={value => {
                  this.setState({ selectedFamilyValues: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Diet</Wrapper>}
                selected={selectedDiet}
                options={diet}
                onChange={value => {
                  this.setState({ selectedDiet: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Smoke</Wrapper>}
                selected={selectedSmoke}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedSmoke: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Drink</Wrapper>}
                selected={selectedDrink}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedDrink: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Select
                label={<Wrapper>Manglik</Wrapper>}
                selected={selectedManglik}
                options={manglik}
                onChange={value => {
                  this.setState({ selectedManglik: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-6">
              <Select
                label={<Wrapper>MoonSign</Wrapper>}
                selected={selectedMoonsign}
                options={moonSign}
                onChange={value => {
                  this.setState({ selectedMoonsign: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Select
                label={<Wrapper>Country</Wrapper>}
                selected={selectedCountry}
                options={country}
                onChange={value => {
                  this.setState({ selectedCountry: value }, () => {
                    getStateData(value);
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-6">
              <Select
                label={<Wrapper>State</Wrapper>}
                selected={selectedState}
                options={state}
                onChange={value => {
                  this.setState({ selectedState: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
        </div>
      </FilterWidget>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  maritalStatus: getMaritalStatus(state),
  motherTongue: getMotherTongue(state),
  religion: getReligion(state),
  isFemale: getMyGender(state),
  bodyType: getBodyType(state),
  education: getEducation(state),
  jobType: getJobType(state),
  income: getIncome(state),
  height: getHeight(state),
  complexion: getComplexion(state),
  familyType: getFamilyType(state),
  familyValue: getFamilyValue(state),
  familyStatus: getFamilyStatus(state),
  diet: getDiet(state),
  habitType: getHabitType(state),
  manglik: getManglik(state),
  moonSign: getMoonSign(state),
  country: getCountry(state),
  state: getState(state)
});
const mapDispatchToProps = dispatch => ({
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion()),
  getBodyTypeData: () => dispatch(dataActions.getBodyType()),
  getFamilyTypeData: () => dispatch(dataActions.getFamilyType()),
  getFamilyValueData: () => dispatch(dataActions.getFamilyValue()),
  getFamilyStatusData: () => dispatch(dataActions.getFamilyStatus()),
  getEducationData: () => dispatch(dataActions.getEducation()),
  getJobTypeData: () => dispatch(dataActions.getJobType()),
  getIncomeData: () => dispatch(dataActions.getIncome()),
  getHeightData: () => dispatch(dataActions.getHeight()),
  getComplexionData: () => dispatch(dataActions.getComplexion()),
  getDietData: () => dispatch(dataActions.getDiet()),
  getHabitTypeData: () => dispatch(dataActions.getHabitType()),
  getManglikData: () => dispatch(dataActions.getHabitType()),
  getMoonSignData: () => dispatch(dataActions.getMoonSign()),
  getCountryData: () => dispatch(dataActions.getCountry()),
  getStateData: country => dispatch(dataActions.getStateByCountry(country)),
  search: payload => dispatch(searchActions.search(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/_components/Search/Advance/Filter/index.js